import React, { useState } from 'react';
import { Link, Outlet } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { useNavigate } from 'react-router-dom';
import { enqueueSnackbar } from 'notistack';
import {
    AppBar,
    Toolbar,
    IconButton,
    Typography,
    Drawer,
    List,
    ListItem,
    ListItemText,
    Box,
    Collapse,
    Menu,
    MenuItem
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AccountCircle from '@mui/icons-material/AccountCircle';

const drawerWidth = 240;

const AdminHome = () => {
    const [open, setOpen] = useState(false);
    const [openForms, setOpenForms] = useState(false);
    const [openWorkflows, setOpenWorkflows] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    
    const token = localStorage.getItem('token');
    const { name } = jwtDecode(token);
    const navigate = useNavigate();

    const toggleDrawer = () => {
        setOpen(!open);
    };

    const handleSignOut = () => {
        localStorage.removeItem('token');
        enqueueSnackbar('Signed out successfully', { variant: 'success' });
        navigate("/");
    };

    const toggleFormsDropdown = () => {
        setOpenForms(!openForms);
    };

    const toggleWorkflowsDropdown = () => {
        setOpenWorkflows(!openWorkflows);
    };

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div>
            <AppBar position="static" sx={{ backgroundColor: 'white', color: '#000' }}>
                <Toolbar>
                    <IconButton edge="start" color="inherit" aria-label="menu" onClick={toggleDrawer}>
                        <MenuIcon />
                    </IconButton>
                    <Typography variant="h6" sx={{ flexGrow: 1, color: '#000' }}>
                        Admin Dashboard
                    </Typography>
                    <IconButton
                        edge="end"
                        color="inherit"
                        aria-label="account"
                        onClick={handleClick}
                        sx={{ fontSize: '2rem' }}
                    >
                        <AccountCircle fontSize="inherit" />
                    </IconButton>
                    <Menu
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                    >
                        <MenuItem disabled><strong>{name}</strong></MenuItem>
                        <MenuItem onClick={handleSignOut}>Sign Out</MenuItem>
                    </Menu>
                </Toolbar>
            </AppBar>

            <Drawer
                sx={{
                    width: drawerWidth,
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        width: drawerWidth,
                        boxSizing: 'border-box',
                    },
                }}
                variant="persistent"
                anchor="left"
                open={open}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', p: 2, justifyContent: 'space-between' }}>
                    <Typography variant="h6">Menu</Typography>
                    <IconButton onClick={toggleDrawer}>
                        <CloseIcon />
                    </IconButton>
                </Box>
                <Box sx={{ padding: 2 }}>
                    <List>
                        <ListItem button onClick={toggleFormsDropdown}>
                            <ListItemText primary="Forms" />
                            {openForms ? <ExpandMoreIcon /> : <ChevronRightIcon />}
                        </ListItem>
                        <Collapse in={openForms} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                                <ListItem button component={Link} to="/admin/forms/create" onClick={toggleDrawer} sx={{ pl: 4 }}>
                                    <ListItemText primary="Create Form" />
                                </ListItem>
                                <ListItem button component={Link} to="/admin/forms/all" onClick={toggleDrawer} sx={{ pl: 4 }}>
                                    <ListItemText primary="All Forms" />
                                </ListItem>
                            </List>
                        </Collapse>

                        <ListItem button onClick={toggleWorkflowsDropdown}>
                            <ListItemText primary="Workflows" />
                            {openWorkflows ? <ExpandMoreIcon /> : <ChevronRightIcon />}
                        </ListItem>
                        <Collapse in={openWorkflows} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                                <ListItem button component={Link} to="/admin/workflows/create" onClick={toggleDrawer} sx={{ pl: 4 }}>
                                    <ListItemText primary="Create Workflow" />
                                </ListItem>
                                <ListItem button component={Link} to="/admin/workflows/all" onClick={toggleDrawer} sx={{ pl: 4 }}>
                                    <ListItemText primary="All Workflows" />
                                </ListItem>
                            </List>
                        </Collapse>

                        <ListItem button component={Link} to="/admin/user-management">
                          <ListItemText primary="User Management" />
                        </ListItem>
                    </List>
                </Box>
            </Drawer>

            <main className="flex justify-center items-center p-10 overflow-auto">
                <Outlet />
            </main>
        </div>
    );
};

export default AdminHome;
